import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { centerTextWrapperStyle, topTextWrapperStyle } from './Navigation.styled';
import { useSetBackground } from '../../../util/hooks/useSetBackground';

export const Navigation = () => {
  useSetBackground('navigation');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 12, pr: 12 }}>
      <Box
        sx={{
          backgroundColor: 'custom.opaqueBackground',
          boxShadow: '2px 5px 10px black',
          borderRadius: '10px',
          p: 1,
          mt: 3,
          width: 'fit-content',
          alignSelf: 'center',
        }}
      >
        <Typography
          color="primary.main"
          variant="h2"
          align="center"
          sx={{ p: 4, alignItems: 'center', display: 'flex', gap: 2 }}
        >
          <FormattedMessage id="navigation.headline" />
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: 'custom.opaqueBlue',
          boxShadow: '2px 5px 10px black',
          borderRadius: '10px',
          mt: 6,
          p: 4,
          width: 'fit-content',
          justifyContent: 'center',
          alignSelf: 'center',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div
            style={{
              position: 'relative',
              textAlign: 'right',
              height: '500px',
              width: '600px',
            }}
          >
            <div
              style={{
                borderRadius: '10px',
                boxShadow: '2px 5px 10px black',
                overflow: 'hidden',
                background: 'none !important',
                height: '500px',
                width: '600px',
              }}
            >
              <iframe
                width="600"
                height="500"
                id="gmap_canvas"
                src={`https://maps.google.com/maps?q=Autoglas%20am%20Rhein%20H%C3%BCrth&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                frameBorder="0"
                scrolling="no"
                marginHeight={0}
                marginWidth={0}
              ></iframe>
              <br />
              <a href="https://www.embedgooglemap.net">how to add google maps to a website</a>
            </div>
          </div>
        </Box>
        <Typography
          color="secondary.main"
          align="center"
          sx={{ pt: 4, alignItems: 'center', display: 'flex' }}
        >
          <FormattedMessage id="navigation.text.1" />
        </Typography>
      </Box>
    </Box>
  );
};
